import { useState } from 'react';
import './ShareBtnDesktopAnimated.css';
import { FacebookShareButton, LinkedinShareButton } from 'react-share';

const ShareBtnDesktopAnimated = ({facebookUrl}) => {

    const [toggleShare, setToggleShare] = useState(false);

  const onShareBtnToggle = () => {
    setToggleShare((prev) => !prev);
  };

  return (
    <button className="btn_rounded_border_animation" onClick={onShareBtnToggle}>
      <span className="btn_rounded_border_animation_text">
        <span>Share Design</span>
        {toggleShare && (
          <FacebookShareButton
            style={{marginLeft: '10px', marginRight: '10px' }}
            url={facebookUrl}
            quote="Please share this post."
            hashtag="#Cotown"
          >
            <svg
              className='facebook_icon_svg'
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="18"
              viewBox="0 0 11 18"
              fill="none"
            >
              <path
                d="M10.2792 10.125L10.8496 6.86742H7.28306V4.75348C7.28306 3.86227 7.78127 2.99355 9.3786 2.99355H11V0.220078C11 0.220078 9.52863 0 8.12184 0C5.18471 0 3.26486 1.56023 3.26486 4.38469V6.86742H0V10.125H3.26486V18H7.28306V10.125H10.2792Z"
                fill="#000000"
              />
            </svg>
          </FacebookShareButton>
        )}
        {toggleShare && (
          <LinkedinShareButton
            url="https://bg.linkedin.com/"
          >
            <svg
              className='linkedin_icon_svg'
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
            >
              <path
                id="Union"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.63636 2.81818C4.63636 4.09848 3.59848 5.13636 2.31818 5.13636C1.03789 5.13636 0 4.09848 0 2.81818C0 1.53789 1.03789 0.5 2.31818 0.5C3.59848 0.5 4.63636 1.53789 4.63636 2.81818ZM11.5909 6.68185C10.8822 6.67959 10.18 6.80711 9.52447 7.05711C8.86892 7.30712 8.27289 7.6747 7.77049 8.13882C7.26809 8.60294 6.86917 9.1545 6.59657 9.76193C6.32397 10.3694 6.18303 11.0207 6.18182 11.6788V16.7273C6.18182 16.9322 6.26949 17.1288 6.42555 17.2737C6.58162 17.4186 6.79328 17.5 7.01399 17.5H8.95571C9.17642 17.5 9.38808 17.4186 9.54414 17.2737C9.7002 17.1288 9.78788 16.9322 9.78788 16.7273V11.6788C9.7877 11.4448 9.84064 11.2133 9.94325 10.9995C10.0459 10.7857 10.1958 10.5944 10.3834 10.4381C10.571 10.2818 10.7919 10.1639 11.0318 10.0921C11.2718 10.0204 11.5253 9.9964 11.7758 10.0217C12.2252 10.0743 12.6382 10.2782 12.9364 10.5947C13.2347 10.9112 13.3975 11.3183 13.3939 11.7389V16.7273C13.3939 16.9322 13.4816 17.1288 13.6377 17.2737C13.7937 17.4186 14.0054 17.5 14.2261 17.5H16.1678C16.3885 17.5 16.6002 17.4186 16.7563 17.2737C16.9123 17.1288 17 16.9322 17 16.7273V11.6788C16.9988 11.0207 16.8578 10.3694 16.5852 9.76193C16.3126 9.1545 15.9137 8.60294 15.4113 8.13882C14.9089 7.6747 14.3129 7.30712 13.6573 7.05711C13.0018 6.80711 12.2996 6.67959 11.5909 6.68185ZM4.63636 8.94056C4.63636 8.54662 4.22121 8.22727 3.70909 8.22727H0.927273C0.415154 8.22727 0 8.54662 0 8.94056V16.7867C0 17.1807 0.415154 17.5 0.927273 17.5H3.70909C4.22121 17.5 4.63636 17.1807 4.63636 16.7867V8.94056Z"
                fill="#000000"
              />
            </svg>
          </LinkedinShareButton>
        )}
      </span>
    </button>
  );
}

export default ShareBtnDesktopAnimated;